import SettingsStore from "@/stores/SettingsStore";
import { Textarea } from "@/components/ui/textarea";
import { useTranslation } from "react-i18next";
import { Label } from "@/components/ui/label";

export function SystemMessageInput() {
  const { t } = useTranslation();
  const systemMessage = SettingsStore(state => state.systemMessage);
  const setSystemMessage = SettingsStore(state => state.setSystemMessage);

  return (
    <div className="space-y-2">
      <Label htmlFor={"systemMessage"}>{t("settings.systemMessage")}</Label>
      <Textarea
        id="systemMessage"
        className="[field-sizing:content] max-h-[500px] min-h-[80px]"
        value={systemMessage}
        onChange={e => setSystemMessage(e.target.value)}
      />
    </div>
  );
}
